import { render, staticRenderFns } from "./AliasG.vue?vue&type=template&id=2389944e&scoped=true"
import script from "./AliasG.vue?vue&type=script&lang=js"
export * from "./AliasG.vue?vue&type=script&lang=js"
import style0 from "./AliasG.vue?vue&type=style&index=0&id=2389944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389944e",
  null
  
)

export default component.exports